<script>
import VueJsonToCsv from 'vue-json-to-csv'
import { toRaw, toValue } from 'vue'

export default {
  props: {
    barcode: String,
    name: String,
    available: Number,
    cart: Array,
    sku: String,
    productsCSV: Object
  },
  data() {
    return {
      newBarcode: this.barcode,
      picture: '',
      product: {},
      image: '',
      amountSelected: 0,

    }
  },
  methods: {
    addSub(ps) {
      if (ps == 's') {
        if (this.amountSelected > 0) {
          this.amountSelected--
          this.removeItemOnce(this.cart, this.barcode)
        }
      } else {
        if (this.amountSelected < this.available) {
          this.amountSelected++
          this.cart.push(this.barcode)
        }
      }
    },
    removeItemOnce(arr, value) {
      var index = arr.indexOf(value)
      if (index > -1) {
        arr.splice(index, 1)
      }
      return arr
    },
  },
  created() {
    //check if it starts with a 0
    if (this.barcode) {
      while (this.newBarcode.charAt(0) === '0') {
        this.newBarcode = this.newBarcode.substring(1)
      }
    }
    this.product = this.productsCSV.filter((el) => el['Variant Barcode'] === this.newBarcode)[0]

    if (this.product) {
      if(this.product['Variant Image']){
        this.image = this.product['Variant Image']
      }else{
        this.image = this.product['Image Src']
      }
    }
    this.newSku = this.sku.split('-', 2)

  },
}
</script>

<template>
  <div class="item-square">
    <div class="name">
      {{ name }}
      <br />
      <span>{{ this.newSku[0] }}</span
      >-{{ this.sku.substring(this.sku.indexOf('-') + 1) }}
    </div>
    <img
      v-if="this.product"
      :src="this.product['Variant Image'] || this.product['Image Src']"
      alt="Item Image"
      loading="lazy"
    />
    <br />
    <div class="amount">Quantity: {{ available }}</div>
    <button @click="addSub('s')">-</button>
    {{ this.amountSelected }}
    <button @click="addSub('p')">+</button>
  </div>
</template>

<style lang="scss" scoped>
.item-square {
  background-color: rgb(33, 33, 75);
  width: 10em;
  padding: 1em;
  margin: 1em;
  border-radius: 0.5em;
}
img {
  width: 10em;
  height: 10em;
  object-fit: cover;
}
button {
  padding: 0.5em;
  width: 2em;
  border-radius: 10px;
}
span {
  color: rgb(248, 158, 173);
}
</style>
